import React from 'react'
import PropTypes from 'prop-types'
import { OrderFormContextProvider, ProductListContextProvider } from './contexts'
import ProductDetail from './components/ProductDetail'

function ProductDetailContainer({ product }) {
  return (
    <ProductListContextProvider singleProduct={product}>
      <OrderFormContextProvider product={product}>
        <ProductDetail product={product} />
      </OrderFormContextProvider>
    </ProductListContextProvider>
  )
}

ProductDetailContainer.propTypes = {
  product: PropTypes.string,
}

export default ProductDetailContainer
